import { render } from "./ConfigCards.vue?vue&type=template&id=85b984d4"
import script from "./ConfigCards.vue?vue&type=script&lang=js"
export * from "./ConfigCards.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__